import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';


import userSlice from '../components/Api/User/userSlice';
import dataDisplayerItemsSlice from '../components/DataDisplayer/dataDisplayerItemsSlice';
import formsDataSlice from '../components/FormElements/formsDataSlice';
import formsSlice from '../components/FormElements/formsSlice';
import pagePreloaderSlice from '../components/PagePreloader/pagePreloaderSlice';
import errorPageSlice from '../components/Pages/Error/errorPageSlice';
import pagesSlice from '../components/Router/pagesSlice';
import authSlice from "../components/AdminPanel/authSlice"
import sopSlice from '../components/apps/sop/components/sopSlice';
import postsSlice from '../components/apps/sop/components/postsSlice';
import applicationSettingsSlice from './applicationSettingsSlice';

export const store = configureStore({
  reducer: {
    applicationSettings: applicationSettingsSlice,
    pages: pagesSlice,
    forms: formsSlice,
    formsData: formsDataSlice,
    pagePreloader: pagePreloaderSlice,
    user: userSlice,
    errorPage: errorPageSlice,
    dataDisplayerItems: dataDisplayerItemsSlice,
    auth: authSlice,
    sop: sopSlice,
    posts: postsSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
